import React, {Component} from 'react'
import { connect } from 'react-redux'
import BuilderAddonsItem from './BuilderAddonsItem'



class BuilderAddons extends Component {

  constructor(props){
    super(props);
  }

  render(){
    const { connectDragPreview, connectDragSource } = this.props;

    return (
      <div className="sppb-addon-lists">
        {
          this.props.builderAddons.map((addon,index)=>{
            return(
              <BuilderAddonsItem
                addon={addon}
                builderAddons={this.props.builderAddons}
                key={index}
                index={index}
                inputName={this.props.inputName}
              />
            )
          })
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  }
}

export default connect(
  mapStateToProps
)(BuilderAddons);



// WEBPACK FOOTER //
// ./src/helpers/form/types/builder-helper/BuilderAddons.js